module.exports = 'ttb.dashboard.latestActivityGrid.component';

angular.module(module.exports, ['ttb.directives.ngAvatar'])
    .component('latestActivityGrid', {
        template:`<div class="card-box latest-projects-box">
                    <h4 class="text-dark  header-title m-t-0">{{$ctrl.getTitle()}}</h4>
                    <div class="table-responsive">
                        <div ng-show="$ctrl.loading" class="loader-1 ng-hide"></div>
                        <table ng-show="!$ctrl.loading" class="table table-striped">
                            <thead>
                                <tr>
                                    <th rowspan='2' translate>DashBoard_Recent_Activities_Item</th>
                                    <th class='text-center' rowspan='2' translate >Estimation_Title</th>
                                    <th class='text-center' rowspan='2' translate >DashBoard_Recent_Activities_Date</th>
                                    <th rowspan='2' translate>Assignee_Title</th>
                                    <th colspan='2' translate>DashBoard_Recent_Activities_Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr ng-repeat="item in $ctrl.items" >
                                    <td class='item-col' style="width:50%;" >
                                         <a class='text-ellipsis' title='{{item.ItemId}}: {{item.ItemTitle }}' href='{{item.url}}'> <i class="issue-type-{{item.ItemTypeId}}"></i><span> {{item.ItemId}}: {{item.ItemTitle}}</a>
                                    </td>
                                    <td class='text-center' style="width:12.5%;" >{{ item.Estimation }}</td>
                                    <td class='text-center' style="width:12.5%;"  >{{ item.DisplayDate }}</td>
                                    <td style="width:12.5%;" >
                                        <user-display user="item.AssignedTo" avatar-size="16" font-size="12"></user-display>
                                    </td>
                                    <td style="width:12.5%;" > {{ item.ToStatus }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>`,
        controller: LatestActivityGrid,
        bindings: {
            team: '<'
        }
    });

function LatestActivityGrid($http, $timeout, latestActivityUrl, backlogUrl, $translate) {
    this.$onChanges = (changes) => {
        if (changes.team && !changes.team.isFirstChange()) {
            this.load(changes.team.currentValue);
        }
    }

    this.getTitle = () => {
        return this.team ?  $translate.instant('DashBoard_Recent_Activities',{team_name: this.team.title}) :  $translate.instant('DashBoard_Project_Recent_Activities');
    }

    this.load = (team) => {
        this.loading = true;
        this.info = 'loading...';
        this.items = [];
        this.backlogUrl = backlogUrl;
        let component = this;

        $http.get(latestActivityUrl, { params: { teamId: team ? team.id : null, timestamp: new Date() } })
            .then(response => {
                    component.loading = false;
                    for (let i in response.data) {
                        let item = response.data[i];
                        item.url = `${component.backlogUrl}/ItemDetails/${item.ItemId}`;
                    }

                    component.items = response.data;
                },
                () => {
                    this.loading = false;
                });
    }
}
LatestActivityGrid.$inject = ['$http', '$timeout', 'latestActivityUrl', 'backlogUrl',  '$translate'];


// WEBPACK FOOTER //
// ./components/latest-activity-grid/latest-activity-grid.component.js